// App.js - Main routing file
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ChecklistPage from './pages/ChecklistPage';
import InvoicePage from './pages/InvoicePage';
import HistoryPage from './pages/HistoryPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Route 1: Home - Invoice Table fill பண்ற page */}
        <Route path="/" element={<HomePage />} />

        {/* Route 2: Checklist - Customer details page */}
        <Route path="/checklist" element={<ChecklistPage />} />

        {/* Route 3: Invoice Preview - Print/PDF page */}
        <Route path="/invoice" element={<InvoicePage />} />
        <Route path="/history" element={<HistoryPage />} />
      </Routes>
    </Router>
  );
}

export default App;